import {useQuery} from 'react-query';

import {getAllWaterSystem} from '.';

const useGetAllWaterSystem = (guid?: string, currentPage?: number) => {
  const {data, isLoading} = useQuery(
    ['get-watrer-system', guid, currentPage],
    getAllWaterSystem,
  );

  return {waterSystemData: data, isLoading};
};

export default useGetAllWaterSystem;
